export default __webpack_public_path__ + "static/media/history.ko-3.b5dda23d.png";